export default __webpack_public_path__ + "static/d4kmbbud@2x-8233fcc58c4c70768612a726bbc933fb.webp";